import React from 'react';
import 'emoji-mart/css/emoji-mart.css';
import { Picker, EmojiData } from 'emoji-mart';

interface EmojiPickerProps {
  selectEmoji: (emoji: EmojiData) => void;
  style?: React.CSSProperties;
}

export const EmojiPicker: React.FC<EmojiPickerProps> = (props) => {
  const onSelect = (emoji: EmojiData) => {
    props.selectEmoji({ ...emoji });
  };

  return (
    <Picker
      onSelect={(emoji) => onSelect({ ...emoji })}
      showPreview={false}
      showSkinTones={false}
      native
      i18n={{
        search: '検索',
        categories: {
          search: '検索結果',
          recent: 'よく使う絵文字',
          people: 'スマイリー & 人',
          nature: '動物 & 自然',
          foods: '食べ物 & 飲み物',
          activity: 'アクティビティ',
          places: '旅行 & 場所',
          objects: 'オブジェクト',
          symbols: '記号',
          flags: '旗',
          custom: 'カスタム',
        },
      }}
      style={props.style ?? undefined}
    />
  );
};
